// Full-viewport film-grain overlay. Previously two stacked SVGs with
// runtime feTurbulence + mix-blend-mode (multiply + screen), which forced
// the compositor to read back the destination buffer every paint frame
// the overlay was on screen — the single biggest CSS perf cost on the
// page on iOS Safari. Now a single tiled PNG with bidirectional alpha-
// only noise baked in, so the GPU uses its fastest path (plain alpha
// composite) for the same visual feel. Tile is generated by
// scripts/generate-grain-tile.ts.
export function Grain() {
  return <div className="grain" aria-hidden="true" />;
}
